<template>
  <div>
    <div class="mt-3">
      <Sell_total/>
    </div>
    <div class="mt-3">
      <Sell_total_member/>
    </div>
    <div class="mt-3">
      <Sell_total_top/>
    </div>
    <div class="mt-3">
      <Sell_cost_month/>
    </div>
  </div>
</template>

<script>
import Sell_total from "@/components/admin/sell/sell_report/Sell_total";
import Sell_total_member from "@/components/admin/sell/sell_report/Sell_total_member";
import Sell_total_top from "@/components/admin/sell/sell_report/Sell_total_top";
import Sell_cost_month from "@/components/admin/sell/sell_report/Sell_cost";
export default {
  name: "Sell_report_all",
  components: {
    Sell_cost_month,
    Sell_total_top,
    Sell_total_member,
    Sell_total
  }
}
</script>

<style scoped>

</style>
